/** Survives full page reload / dev HMR when Angular recreates the container but IndexedDB load is async. */
const STORAGE_KEY = "cbta.ratingSessionShell";

export interface RatingSessionShellCache {
	routeKey: string;
	formType?: string;
	/** Survives full reload so TS-1 can resolve shell without waiting on IndexedDB. */
	ratingFormUiVersion?: number;
}

function readAll(): Record<string, RatingSessionShellCache> {
	try {
		const raw = sessionStorage.getItem(STORAGE_KEY);
		if (!raw) return {};
		const parsed = JSON.parse(raw) as Record<string, RatingSessionShellCache>;
		return parsed && typeof parsed === "object" ? parsed : {};
	} catch {
		return {};
	}
}

function writeAll(entries: Record<string, RatingSessionShellCache>): void {
	try {
		sessionStorage.setItem(STORAGE_KEY, JSON.stringify(entries));
	} catch {
		// non-blocking — private browsing / quota
	}
}

export function readRatingSessionShell(routeKey: string): RatingSessionShellCache | null {
	if (!routeKey) return null;
	const entry = readAll()[routeKey];
	if (!entry || entry.routeKey !== routeKey) return null;
	return entry;
}

export function writeRatingSessionShell(cache: RatingSessionShellCache): void {
	if (!cache.routeKey) return;
	const all = readAll();
	all[cache.routeKey] = cache;
	writeAll(all);
}

export function clearRatingSessionShell(routeKey?: string): void {
	if (!routeKey) {
		try {
			sessionStorage.removeItem(STORAGE_KEY);
		} catch {
			// ignore
		}
		return;
	}
	const all = readAll();
	if (!(routeKey in all)) return;
	delete all[routeKey];
	writeAll(all);
}
